import { useState, useEffect } from "react";
import { useLensApp } from "../useLensApp.jsx";

export default function ApiSection() {
  const { settings, actions } = useLensApp();
  const [port, setPort] = useState(String(settings?.apiPort || 4789));
  const [enabled, setEnabled] = useState(settings?.apiEnabled === false ? "false" : "true");
  const [tokenNotice, setTokenNotice] = useState("");

  useEffect(() => { setPort(String(settings?.apiPort || 4789)); }, [settings?.apiPort]);
  useEffect(() => { setEnabled(settings?.apiEnabled === false ? "false" : "true"); }, [settings?.apiEnabled]);

  return (
    <section>
      <h3>HTTP API</h3>
      <div className="field">
        <label htmlFor="apiPortInput">Port</label>
        <div className="row">
          <input
            id="apiPortInput"
            type="number"
            min="1"
            max="65535"
            step="1"
            value={port}
            onChange={(event) => setPort(event.target.value)}
          />
          <button
            className="primary"
            onClick={() => actions.saveApiSettings({
              apiPort: Number.parseInt(port, 10),
              apiEnabled: enabled === "true",
            }).catch(actions.setError)}
          >
            Save
          </button>
        </div>
      </div>
      <div className="field">
        <label htmlFor="apiEnabledInput">Enabled</label>
        <select
          id="apiEnabledInput"
          value={enabled}
          onChange={(event) => {
            const next = event.target.value;
            setEnabled(next);
            actions.saveApiSettings({
              apiPort: Number.parseInt(port, 10),
              apiEnabled: next === "true",
            }).catch(actions.setError);
          }}
        >
          <option value="true">On</option>
          <option value="false">Off</option>
        </select>
      </div>
      {settings?.apiAuthRequired && (
        <div className="field">
          <label>Authentication</label>
          <div className="hint flush">
            Control and state requests require <code>Authorization: Bearer &lt;token&gt;</code>.
            The credential is protected by {settings.apiCredentialProtection === "os-credential-store"
              ? "the operating system credential store"
              : "a current-user-only file"}.
          </div>
          <div className="button-row">
            <button onClick={() => actions.copyApiToken().then(() => {
              setTokenNotice("Token copied");
              window.setTimeout(() => setTokenNotice(""), 1800);
            }).catch(actions.setError)}>
              Copy API token
            </button>
            <button className="danger" onClick={() => {
              if (!window.confirm("Rotate the API token? Existing integrations will stop working until updated.")) return;
              actions.rotateApiToken().then(() => {
                setTokenNotice("Token rotated");
                window.setTimeout(() => setTokenNotice(""), 1800);
              }).catch(actions.setError);
            }}>Rotate token</button>
            {tokenNotice && <span className="hint">{tokenNotice}</span>}
          </div>
        </div>
      )}
    </section>
  );
}
